import { render } from "./PlayerHeader.vue?vue&type=template&id=725b5747&ts=true"
import script from "./PlayerHeader.vue?vue&type=script&lang=ts"
export * from "./PlayerHeader.vue?vue&type=script&lang=ts"

import "./PlayerHeader.vue?vue&type=style&index=0&id=725b5747&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__